export default __webpack_public_path__ + "static/media/dole-juice-pattern.2960fe80.svg";